module.exports = __webpack_public_path__ + "static/media/homework-card-footer.8b27865d.png";